<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.device_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.device_form.edit_form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.device_form.error_list_title") }}</b>
          <div class="alert alert-warning" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>

        <form v-if="input">
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.device_form.label_serial_number')"
                outlined
                v-model="input.serial_number"
              ></v-text-field>
            </div>

            <div class="select-box col-md-6">
              <v-select
                :items="readerTypes"
                v-model="input.reader_type"
                item-value="value"
                :label="$t('lang.admin.device_form.label_reader_type')"
                outlined
              ></v-select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.device_form.label_mac_address')"
                outlined
                v-model="input.mac_address"
              ></v-text-field>
            </div>
            <div class="select-box col-md-6">
              <v-select
                :items="locations"
                item-text="description"
                v-model="input.locationArea1"
                item-value="id"
                :label="$t('lang.admin.device_form.label_select_location')"
                outlined
              ></v-select>
            </div>
          </div>
          <div class="form-row">
            <div class="select-box col-md-6">
              <v-select
                :disabled="input.reader_type != 1"
                :items="workingModes"
                item-text="title"
                v-model="input.working_mode"
                item-value="value"
                :label="$t('lang.admin.device_form.label_working_mode')"
                outlined
              ></v-select>
            </div>
            <div class="col-md-6" v-if="device">
              <v-text-field
                v-if="device.state == 'ON'"
                outlined
                disabled
                :label="$t('lang.admin.label_state')"
                prepend-inner-icon="mdi-play-circle-outline"
                v-model="success.running"
              ></v-text-field>
              <v-text-field
                v-else
                outlined
                disabled
                :label="$t('lang.admin.label_state')"
                prepend-inner-icon="mdi-pause-circle-outline"
                v-model="success.stopped"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded type="reset" @click="$router.back()">{{
                $t("lang.location_form.btn_cancel")
              }}</v-btn>
              <bx-btn type="submit" color="primary" @click="submitForm">{{
                $t("lang.admin.device_form.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="centros-formbg" v-if="device">
      <h6>Aplicaciones</h6>
      <div class="centros-form">
        <form v-if="input">
          <div class="form-row d-flex align-items-end">
            <div class="container-fluid">
              <v-row class="d-flex d-sm-none">
                <v-list width="100%">
                  <v-list-item
                    two-line
                    v-for="(item, index) in data"
                    :key="index"
                    class="green lighten-5 ma-2 rounded-lg"
                    ripple
                  >
                  </v-list-item>
                </v-list>
              </v-row>
              <div class="row">
                <bx-box
                  :title="totalLocations + ' apps instaladas'"
                  color="white"
                  no-padding
                  class="col-12"
                >
                  <template v-slot:default>
                    <skeleton-table :columns="3" v-if="false" />

                    <bx-table
                      :data="data"
                      paginated
                      backendPagination
                      :columns="columns"
                    >
                      <template slot-scope="props">
                        <bx-table-column centered class="pt-5">
                          {{ props.row.application }}
                        </bx-table-column>
                        <bx-table-column centered class="pt-5">
                          {{ props.row.version_name }}
                        </bx-table-column>
                        <bx-table-column centered class="pt-5">
                          <div class="d-flex align-items-center">
                            <v-switch
                              v-model="props.row.running"
                              inset
                              class="custom-switch"
                              @change="
                                enableState(props.row.running, props.row.id)
                              "
                              :disabled="device.state === 'OFF'"
                            ></v-switch>
                          </div>
                        </bx-table-column>
                        <bx-table-column centered class="pt-5">
                          <div class="d-flex align-items-center">
                            <Configuration
                              :data="props.row"
                              :id="props.row.id"
                              :state="device.state"
                            >
                            </Configuration>
                          </div>
                        </bx-table-column>
                        <bx-table-column centered class="pt-5">
                          <DeleteApplication
                            :id="props.row.id"
                            :state="device.state"
                          ></DeleteApplication>
                        </bx-table-column>
                      </template>
                    </bx-table>
                  </template>
                </bx-box>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Configuration from "@/components/EditConfiguration";
import DeleteApplication from "@/components/DeleteApplication";
let workingModes = [
  { value: 0, title: "Entry" },
  { value: 1, title: "Movement Exit" },
  { value: 2, title: "Handheld" },
  { value: 3, title: "Movement" },
  { value: 4, title: "Sale" },
  { value: 5, title: 'POS'},
  { value: 6, title: "Exit/Sale" },
  { value: 7, title: "Cabinet" },
];

let readerTypes = [
  { value: 0, text: "Normal" },
  { value: 1, text: "All" }
];

export default {
  components: { Configuration, DeleteApplication },
  name: "AddUserForm",
  props: ["id"],
  data() {
    return {
      data: [],
      input: null,
      device: null,
      errors: [],
      locations: [],
      workingModes: workingModes,
      readerTypes: readerTypes,
      totalLocations: 0,
      success: {
        show: false,
        message: this.$t("lang.admin.device_form.success_edit"),
        running: this.$t("lang.admin.device_form.running"),
        stopped: this.$t("lang.admin.device_form.stopped")
      },
      errorLabels: {
        serialNumber: this.$t("lang.admin.device_form.errors.serial_number"),
        macAddress: this.$t("lang.admin.device_form.errors.mac_address"),
        location: this.$t("lang.admin.device_form.errors.location"),
        notFound: this.$t("lang.admin.device_form.errors.not_found"),
        failed: this.$t("lang.messages.label_something_went_wrong")
      },
      columns: []
    };
  },
  async mounted() {
    try {
      this.locations = await this.$api.area.list();
      this.input = await this.$api.device.get(this.id);
      let dev = await this.$api.nms.get_device(this.input.mac_address);
      this.device = dev[0];
      this.getData();
    } catch (error) {
      this.errors.push(this.errorLabels.notFound);
    }
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.input);

      if (this.validate()) {
        input.locationArea = parseInt(input.locationArea1);

        try {
          let response = await this.$api.device.update(input);
          this.success.show = true;
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
          console.error(error);
        }
      }
    },
    validate() {
      this.errors = [];
      this.success.show = false;

      let error = false;

      if (!this.input.serial_number) {
        error = true;
        this.errors.push(this.errorLabels.serialNumber);
      }

      if (!this.input.mac_address) {
        error = true;
        this.errors.push(this.errorLabels.macAddress);
      }

      if (!this.input.locationArea1) {
        error = true;
        this.errors.push(this.errorLabels.location);
      }

      if (error) {
        return false;
      }

      return true;
    },
    async getData() {
      let locations = await this.$api.nms.list_device_apps(
        this.device ? this.device.id : ""
      );
      this.data = locations.results;
      this.totalLocations = locations.count;
      this.columns = [
        {
          field: "Application",
          label: this.$t("lang.admin.label_app"),
          centered: true
        },
        {
          field: "version",
          label: this.$t("lang.admin.label_version"),
          centered: true
        },
        {
          field: "state",
          label: this.$t("lang.admin.label_state"),
          left: true
        },
        {
          field: "configuration",
          label: this.$t("lang.admin.label_configuration"),
          left: true
        },
        {
          field: "",
          label: this.$t("lang.admin.label_action"),
          centered: true
        }
      ];
    },
    stateName(state) {
      if (state === true) {
        return this.$t("lang.admin.online");
      } else if (state === false) {
        return this.$t("lang.admin.offline");
      } else {
        return "";
      }
    },
    stateNumber(state) {
      if (state === "ON") {
        return 3;
      } else if (state === "OFF") {
        return 2;
      } else {
        return "";
      }
    },
    async enableState(state, id) {
      if (state) {
        await this.$api.nms.start_application_state(id, state);
      } else {
        await this.$api.nms.stop_application_state(id, state);
      }
    }
  }
};
</script>
